import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AppDialogComponent from "components/mui/AppDialogComponent";
import AppTextFieldComponent from "components/mui/AppTextFieldComponent";
import AppButtonComponent from "components/mui/AppButtonComponent";
import { FormControl, Select, MenuItem } from "@mui/material";
// Component scope - Constants
const SUCCESS_ICON_SX = {
  fontSize: 60,
  color: "#28C76F",
  mb: 2,
};

const SUCCESS_CONTAINER_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  py: 5,
  textAlign: "center",
};

/**
 * Service Request Modal Component
 * Pure UI component for displaying service request form or success message
 * @component
 */
const ServiceRequestModal = ({
  open = false,
  onClose,
  onSubmit,
  loading = false,
  showSuccess = false,
  query = "",
  reason = "",
  reasons = [],
  onReasonChange,
  onQueryChange,
  disabled = false,
  minLength = 0,
  maxLength = 1000,
  modalTitle = "Need Help? Reach Out to us",
}) => {
  // Calculate character count
  const charCount = query?.length || 0;
  const isMinLengthMet = charCount >= minLength;
  const isMaxLengthExceeded = charCount > maxLength;
  const isReasonSelected = reason && reason.trim() !== "";
  const isQueryEmpty = !query || query.trim().length === 0;

  // Validation logic
  const isFormValid =
    isReasonSelected && !isQueryEmpty && isMinLengthMet && !isMaxLengthExceeded;
  // Return/rendering
  return (
    <AppDialogComponent
      open={open}
      onClose={onClose}
      title={showSuccess ? "" : modalTitle}
      //   maxWidth={false}
      //   fullWidth={true}
      showCloseButton={true}
      sx={{
        "& .MuiDialog-paper": {
          bgcolor: "#1A1F33",
          color: "#fff",
          borderRadius: "12px",
          padding: "24px",
          width: "100%",
          maxWidth: {
            xs: "90vw",
            sm: "335px",
            md: "400px",
          },

          //   maxWidth: '400px',
          minHeight: "256px",
          margin: {
            xs: "16px",
            sm: "auto",
          },
        },
        "& .MuiDialogTitle-root": {
          padding: 0,
          paddingBottom: "18px",
        },
        "& .MuiDialogContent-root": {
          padding: 0,
          gap: "24px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {showSuccess ? (
        <Box sx={SUCCESS_CONTAINER_SX}>
          <CheckCircleOutlineIcon sx={SUCCESS_ICON_SX} />
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#F0F0F0", fontWeight: 600, mb: "5" }}
          >
            Query Submitted successfully.
          </Typography>
          <Typography variant="body2" sx={{ color: "#CCCCCC" }}>
            Your RM will get back to you soon to resolve your query.
          </Typography>
        </Box>
      ) : (
        <Box
          component="form"
          onSubmit={onSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Dropdown for reasons */}
          {/* <AppTextFieldComponent
            label="Select Reason"
            value={reason}
            onChange={onReasonChange}
            fullWidth
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiOutlinedInput-root': {
                color: '#F0F0F0',
                '& fieldset': {
                  borderColor: '#3A3A3A'
                },
                '&:hover fieldset': {
                  borderColor: '#D8D8D8',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#46A8DC'
                }
              },
              '& .MuiInputLabel-root': {
                color: '#CCCCCC',
                position: 'absolute',
                left: '10px',
                // padding: '0 40px',
                zIndex: 1000,
                transform: 'none',
                fontSize: '13px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                '&.MuiInputLabel-shrink': {
                  transform: 'none',
                  top: '-4px',
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#46A8DC'
              },
              '& .MuiOutlinedInput-notchedOutline': {
                top: 0,
              },
              '& .MuiInputBase-input': {
                paddingTop: '20px'
              }
            }}
          /> */}
          {/* <FormControl fullWidth sx={{ position: 'relative' }}>
            <Typography
              sx={{
                position: 'absolute',
                top: '-9px',
                left: '10px',
                fontSize: '13px',
                color: reason ? '#46A8DC' : '#CCCCCC',
                bgcolor: '#1A1F33',
                px: '4px',
                zIndex: 1,
                pointerEvents: 'none',
                lineHeight: 1,
              }}
            >
              Select Reason
            </Typography>

            <Select
              value={reason}
              onChange={onReasonChange}
              disabled={loading}
              displayEmpty
              renderValue={(selected) => (
                <Typography sx={{ color: selected ? '#F0F0F0' : '#888888', fontSize: '14px' }}>
                  {selected || ''}
                </Typography>
              )}
              MenuProps={{
                disablePortal: false,
                disableScrollLock: true,
                PaperProps: {
                  sx: {
                    bgcolor: '#1A1F33',
                    color: '#F0F0F0',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    mt: '4px',
                    border: '1px solid #3A3A3A',
                    borderRadius: '8px',
                    zIndex: 99999,
                    '& .MuiMenuItem-root': {
                      color: '#F0F0F0',
                      fontSize: '13px',
                      py: '10px',
                      px: '14px',
                      '&:hover': { bgcolor: '#2A2F45' },
                      '&.Mui-selected': {
                        bgcolor: '#2A3A4A',
                        '&:hover': { bgcolor: '#2A3A4A' }
                      }
                    },
                    '& .MuiList-root': { padding: 0 }
                  }
                },
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
              }}
              sx={{
                bgcolor: '#1A1F33',
                borderRadius: '8px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3A3A3A',
                  '& legend': { width: 0 }
                },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#D8D8D8' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#46A8DC' },
                '& .MuiSvgIcon-root': { color: '#F0F0F0' }
              }}
            >
              {reasons.map((item) => (
                <MenuItem key={item} value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <AppTextFieldComponent
            label="Select Reason"
            value={reason}
            // placeholder="Select Reason"
            onChange={onReasonChange}
            fullWidth
            select
            required
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#F0F0F0",
                "& fieldset": { borderColor: "#3A3A3A" },
                "&:hover fieldset": { borderColor: "#D8D8D8" },
                "&.Mui-focused fieldset": { borderColor: "#46A8DC" },
              },
              "& .MuiInputLabel-root": {
                color: "#CCCCCC",
                position: "absolute",
                left: "10px",
                zIndex: 1000,
                transform: "none",
                fontSize: "13px",
                "&.MuiInputLabel-shrink": { transform: "none", top: "-4px" },
              },
              "& .MuiInputLabel-root.Mui-focused": { color: "#46A8DC" },
              "& .MuiInputLabel-asterisk": { color: "#EF4444" },
              "& .MuiOutlinedInput-notchedOutline": { top: 0 },
              "& .MuiSvgIcon-root": { color: "#F0F0F0" },
            }}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) => (
                <Typography
                  sx={{
                    color: selected ? "#F0F0F0" : "#888888",
                    fontSize: "14px",
                  }}
                >
                  {selected || "Choose a reason"}
                </Typography>
              ),
              MenuProps: {
                disablePortal: false,
                disableScrollLock: true,
                PaperProps: {
                  sx: {
                    bgcolor: "#1A1F33",
                    color: "#F0F0F0",
                    maxHeight: "200px",
                    overflowY: "auto",
                    mt: "4px",
                    border: "1px solid #3A3A3A",
                    borderRadius: "8px",
                    zIndex: 99999,
                    "& .MuiMenuItem-root": {
                      color: "#F0F0F0",
                      fontSize: "13px",
                      py: "10px",
                      px: "14px",
                      "&:hover": { bgcolor: "#2A2F45" },
                      "&.Mui-selected": {
                        bgcolor: "#2A3A4A",
                        "&:hover": { bgcolor: "#2A3A4A" },
                      },
                    },
                    "& .MuiList-root": { padding: 0 },
                  },
                },
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              },
            }}
          >
            {reasons.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </AppTextFieldComponent>

          <AppTextFieldComponent
            label="Enter your query"
            placeholder=""
            value={query}
            onChange={onQueryChange}
            fullWidth
            multiline
            rows={4}
            required
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#F0F0F0",
                "& fieldset": {
                  borderColor: "#3A3A3A",
                },
                "&:hover fieldset": {
                  borderColor: "#D8D8D8",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#46A8DC",
                },
              },
              "& .MuiInputLabel-root": {
                color: "#CCCCCC",
                position: "absolute",
                left: "10px",
                // padding: '0 40px',
                zIndex: 1000,
                transform: "none",
                fontSize: "13px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                "&.MuiInputLabel-shrink": {
                  transform: "none",
                  top: "-4px",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#46A8DC",
              },
              "& .MuiInputLabel-asterisk": { color: "#EF4444" },
              "& .MuiOutlinedInput-notchedOutline": {
                top: 0,
              },
              "& .MuiInputBase-input": {
                paddingTop: "20px",
              },
            }}
          />

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: -2, px: 1 }}
          >
            <Typography
              variant="caption"
              sx={{
                color: isMaxLengthExceeded ? "#FF4D4F" : "#CCCCCC",
                fontSize: "12px",
              }}
            >
              {charCount}/{maxLength}
            </Typography>
          </Box>

          <AppButtonComponent
            type="submit"
            variant="contained"
            fullWidth
            loading={loading}
            disabled={disabled || !isFormValid}
            sx={{
              bgcolor: "#46A8DC",
              "&:hover": {
                bgcolor: "#3B8DB8",
              },
              "&:disabled": {
                bgcolor: "rgba(70, 168, 220, 0.3)",
                color: "rgba(255, 255, 255, 0.5)",
              },
            }}
          >
            Submit
          </AppButtonComponent>
        </Box>
      )}
    </AppDialogComponent>
  );
};

ServiceRequestModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  showSuccess: PropTypes.bool,
  query: PropTypes.string,
  onQueryChange: PropTypes.func.isRequired,
  reason: PropTypes.string,
  reasons: PropTypes.arrayOf(PropTypes.string),
  onReasonChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  modalTitle: PropTypes.string,
};

export default ServiceRequestModal;
